import Stringifier from "postcss/lib/stringifier";
import Util from '../../Common/Util';

export default class Biz {
    constructor() {
    }

    /**
     * 지정발주 또는 외부발주
     */
    baljooToOther(data){
        // console.log(data);
        const ordernum = data['num'];
        const mb_no = data.$r['worker_num'];
        let mem_name = data.$r['hp_name'];
        let mem_phone = data.$r['hp'];
        let is_fee= data.$r['is_fee'];
        let from = data.$p['from'];

        let who ='[ 회원 ]'
        if( !mb_no){// 외부발주
            who = '[ 비회원 ]';
            is_fee=0;
        }
        if(!mem_phone) return;
        mem_phone=Util.phoneNumber(mem_phone);

        // 도착시간 체크
        let moreMg='';
        let lastGab = dayjs(data['work_time']).diff(dayjs(), 'minute');
        if( lastGab < 40 ){
            if( lastGab < 0 ){
                moreMg = "\n\n알림 !!! : 현장도착시간이 지났습니다" ;
            }else{
                moreMg = "\n\n알림 !!! : 현장도착 시간이 "+ lastGab + " 분 이전입니다.";
            }
        }

        // 수수료
        let Peeshow = "수수료 : 10% ";
        if( is_fee==0){
            Peeshow = "수수료 : 없음 ";
        }
        if( Util.isSosokSamsung(MEMBER['sosok']) ) Peeshow = "";
        // swalert 는 제목에 '<' 가 있으면 HTML 로 그린다 — 다른 회원 이름이 태그로 읽히지 않게 '<' 만 전각으로
        const nameTxt = String(mem_name ?? '').replace(/</g, '＜');
        let body = `${nameTxt} : ${mem_phone}\n위 전화번호로 수주자를 변경할까요?\n\n ${who} ${Peeshow} ${moreMg}`;
        let title = '수주자 변경';
        if( from=='수주'){
            title = '전달하기';
            body = `${nameTxt} (${mem_phone}) 님 에게 전달하시겠습니까?`;
        }

        Util.swalert(body, function(){
            // "예" 를 선택했을때
            var adr = `/m/ajax/order/${ordernum}/forward`;
            var sendData = {
                "todirectpersonno": mb_no,
                "todirectpersonname": mem_name,
                "directhpnum": mem_phone,
                'is_fee': is_fee,
            };
            // page_chnage();
            $j.Common.Util.loadingOverlay(true);
            $.ajax({
                type: "POST",
                url: adr,
                data: sendData,
                success: function (data) {
                    if(!data.result){
                        alert(data.message);
                        $j.Common.Util.loadingOverlay(false);
                        return;
                    }
                    // 내부적인 처리가 (큐방식) 완료되려면 약간의 시간이 필요하여 시간지연이 필요하다.
                    setTimeout(function(){
                        document.location.href = "?showipicknum=" + ordernum;
                    },1500);

                }
            });
        }, ['예','아니오']);
    }

    /**
     * 결제 책임 문구
     * @param howtopay
     * @param howlong
     */
    howtopayStr(howtopay, howlong){
        let str = G5['HOW_TO_PAY'][howtopay];
        if( howtopay==1 ){
            let s = this.sign_due_str(howlong);
            str+=` (${s})`;
        }
        return str;
    }

    /**
     * 싸인 결제일
     * @param howlong
     * @returns {*}
     */
    sign_due_str(howlong){
        if (howlong in G5['SIGN_DUE']) return G5['SIGN_DUE'][howlong];

        return howlong+'일';
    }

}